<div fxLayout="column" class="app-dialog-background p-20">
    <!-- success state -->
    <div class="error-title mt-40">
        {{ (gseResponse.success ? 'Data uploaded successfully' : 'Data uploading failed')|i18n }}
    </div>
    <!-- errors -->
    <ng-container *ngIf="gseResponse.errors?.length">
        <div class="error-text mt-40">{{ 'The file has the following errors:'|i18n }}</div>
        <ul>
            <li *ngFor="let error of gseResponse.errors" class="error-text">{{ mkErrorMessage(error) }}</li>
        </ul>
    </ng-container>
    <!-- missing pods -->
    <ng-container *ngIf="gseResponse.missing_pods?.length">
        <div class="error-text mt-20">{{ 'Missing PODs that could not be uploaded due to absence in the GSE file:'|i18n }}</div>
        <ul>
            <li *ngFor="let pod of gseResponse.missing_pods" class="error-text">{{ pod }}</li>
        </ul>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" economics-warning>
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'The month will be consolidated in the platform only when all PODs are consolidated.'|i18n }}</div>
        </div>
    </ng-container>
</div>
